import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6b4e1916")

_pushScopeId("data-v-6b4e1916")
const _hoisted_1 = { class: "layers-management-filters" }
const _hoisted_2 = {
  key: 0,
  class: "p-grid"
}
const _hoisted_3 = { class: "p-col" }
const _hoisted_4 = { class: "kn-list-item-text" }
const _hoisted_5 = { class: "p-col" }
const _hoisted_6 = { class: "kn-list-item-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Listbox = _resolveComponent("Listbox")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.layer)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
              start: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('managers.layersManagement.layerFilter')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Listbox, {
              class: "kn-list layers-management-property-container",
              options: _ctx.filters,
              filter: true,
              filterPlaceholder: _ctx.$t('common.search'),
              optionLabel: "property",
              filterMatchMode: "contains",
              filterFields: _ctx.layersManagementFilterTabDescriptor.filterFields,
              emptyFilterMessage: _ctx.$t('common.info.noDataFound'),
              "data-test": "available-properties-list"
            }, {
              empty: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
              ]),
              option: _withId((slotProps) => [
                _createVNode("div", {
                  class: "kn-list-item",
                  onClick: ($event: any) => (_ctx.addProperty(slotProps.option))
                }, [
                  _createVNode("div", _hoisted_4, [
                    _createVNode("span", {
                      "data-test": 'available-property-' + slotProps.option.property
                    }, _toDisplayString(slotProps.option.property), 9, ["data-test"])
                  ])
                ], 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["options", "filterPlaceholder", "filterFields", "emptyFilterMessage"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
              start: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('managers.layersManagement.layerFilterAdded')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Listbox, {
              class: "kn-list layers-management-property-container",
              options: _ctx.layer.properties,
              filter: true,
              filterPlaceholder: _ctx.$t('common.search'),
              optionLabel: "property",
              filterMatchMode: "contains",
              filterFields: _ctx.layersManagementFilterTabDescriptor.filterFields,
              emptyFilterMessage: _ctx.$t('common.info.noDataFound'),
              "data-test": "selected-properties-list"
            }, {
              empty: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('managers.layersManagement.noFilterSelected')), 1)
              ]),
              option: _withId((slotProps) => [
                _createVNode("div", {
                  class: "kn-list-item",
                  onClick: ($event: any) => (_ctx.removeProperty(slotProps.option))
                }, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("span", null, _toDisplayString(slotProps.option.property), 1)
                  ])
                ], 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["options", "filterPlaceholder", "filterFields", "emptyFilterMessage"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})